function getConditionalRoutes() {
  const idPerfil = window.sessionStorage.getItem("idPerfil");
  const routes = [];

  if (!idPerfil) {
    return routes;
  }

  if (idPerfil === "1" || idPerfil === "17" || idPerfil === "19" || idPerfil === "22") {
    routes.push({
      path: "/tramite",
      name: "Trámites",
      component: () => import("@/views/forms/Tramite.vue"),
      meta: { title: "Trámites" },
    });
  }

  if (idPerfil === "1" || idPerfil === "17" || idPerfil === "19") {
    routes.push({
      path: "/tramite-finalizados",
      name: "Trámites Finalizados",
      component: () => import("@/views/forms/TramiteFinalizados.vue"),
      meta: { title: "Trámites Finalizados" },
    });
  }

  if (idPerfil === "1" || idPerfil === "17" || idPerfil === "19" || idPerfil === "18" || idPerfil === "20" || idPerfil === "22") {
    routes.push({
      path: "/tramite-asignados",
      name: "Trámites asignados",
      component: () => import("@/views/reportes/TramitesAsignados.vue"),
      meta: { title: "Trámites asignados" },
    });
  }

  if (idPerfil === "1" || idPerfil === "17" || idPerfil === "19" || idPerfil === "22") {
    routes.push({
      path: "/tramite-procesados",
      name: "Trámites Procesados",
      component: () => import("@/views/reportes/TramitesProcesados.vue"),
      meta: { title: "Trámites procesados" },
    });
  }

  if (idPerfil === "15") { 
    routes.push({
      path: "/tramite-carga",
      name: "Carga de Trámites",
      component: () => import("@/views/forms/TramiteCarga.vue"),
      meta: { title: "Carga de trámites" },
    });
    routes.push({
      path: "/excel-to-csv",
      name: "ExcelToCsv",
      component: () => import("@/components/ExcelToCsv.vue"),
      meta: { title: "Excel a CSV" },
    });
  }
  if (idPerfil === "21") {
    routes.push({
      path: "/tramite-consulta",
      name: "Consulta de Trámites",
      component: () => import("@/views/forms/TramiteConsulta.vue"),
      meta: { title: "Consulta de trámites" },
    });
  }

  return routes;
}

const baseRoutes = [];

const routes = baseRoutes.concat(getConditionalRoutes());

export { routes };
